import * as React from 'react';
import { HeaderBas } from './HeaderBAS';
import { HeaderKit } from './HeaderKit';
import { decodeHtmlEntities } from "../Helper/TextReplacer";
export var HeaderElements = function (_a) {
  var canIndex = _a.canIndex,
    title = _a.title,
    description = _a.description;
  var isBASDomain = window.layoutSettings.hash === '';
  if (isBASDomain) {
    return /*#__PURE__*/React.createElement(HeaderBas, null);
  } else {
    return /*#__PURE__*/React.createElement(HeaderKit, {
      canIndex: canIndex,
      title: decodeHtmlEntities(title),
      description: decodeHtmlEntities(description)
    });
  }
};